import { CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS } from "@framework/types";

export const STATION_TILE_ANALYTICS_ROWS = [
  { id: "1", labelMessageId: "pages.scheme.stationTile.analytics.vibrationVelocity" },
  { id: "2", labelMessageId: "pages.scheme.stationTile.analytics.vibrationAcceleration" },
  { id: "11", labelMessageId: "pages.scheme.stationTile.analytics.temperature" },
  { id: "3", labelMessageId: "pages.scheme.stationTile.analytics.defects" },
  { id: "4", labelMessageId: "pages.scheme.stationTile.analytics.events" },
  { id: "5", labelMessageId: "pages.scheme.stationTile.analytics.lastRepair" },
  { id: "6", labelMessageId: "pages.scheme.stationTile.analytics.plannedMaintenance" },
  { id: "7", labelMessageId: "pages.scheme.stationTile.analytics.surveys" },
  { id: "8", labelMessageId: "pages.scheme.stationTile.analytics.reports" },
  { id: "9", labelMessageId: "pages.scheme.stationTile.analytics.anomalies" },
  { id: "10", labelMessageId: "pages.scheme.stationTile.analytics.forecast" },
] as const;

export const STATION_TILE_ANALYTICS_ROW_IDS: readonly string[] = STATION_TILE_ANALYTICS_ROWS.map(row => row.id);

if (STATION_TILE_ANALYTICS_ROW_IDS.join(",") !== CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS.join(",")) {
  throw new Error("STATION_TILE_ANALYTICS_ROW_IDS must match CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS.");
}

export const STATION_TILE_ANALYTICS_LABEL_MESSAGE_IDS: Record<string, string> = Object.fromEntries(
  STATION_TILE_ANALYTICS_ROWS.map(row => [row.id, row.labelMessageId]),
);
